import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
`;

export default class AufkleberVorschau extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log("we here")
    let arr = [...this.props.fullInfo];
    arr.pop();

    for (let i = 0; i < arr.length; i++) {
      arr[i].text = this.props.zeilenInhalt[i];
    }

    if (this.props.zeilenAnzahl.length > 1) {
      arr.splice(this.props.zeilenAnzahl.length, 100);
    }

    let paddingBottom = "0";

    if (this.props.zeilenabstand > 3) {
      paddingBottom = "8%";
    }

    return (
      <Wrapper id="outer-sample-new">
        <div id="mk-vorschau" style={{ paddingBottom: paddingBottom }}>
          {/* <img src="" alt="" id="mk-img" /> */}

          <svg
            style={{ backgroundColor: "#F5F5F5" }}
            xmlns="http://www.w3.org/2000/svg"
            className={this.props.mirrowed}
            id="mk-svg"
            width="100%"
            height="100%"
            viewBox={"0 0 " + this.props.width + " " + this.props.height}
            preserveAspectRatio="xMidYMid meet"
          >
            <text id="mk-svg-text">
              {arr.map((obj, index) => {
                const letterSpace = `${
                  (1 + 2 * obj.letterSpacing - 1) * 0.5
                }px`;
                const zeilenAbstand = `${
                  0.7 + 0.1 * this.props.zeilenabstand
                }em`;
                return (
                  <tspan
                    key={index}
                    x={this.props.x}
                    dy={zeilenAbstand}
                    className={`mk-tspan svg-line-${index}`}
                    id="sample"
                    textAnchor={this.props.anchor}
                    fill={obj.color}
                    style={{
                      fontFamily: obj.font,
                      fontSize: obj.fontSize,
                      letterSpacing: letterSpace,
                    }}
                  >
                    {obj.text}
                  </tspan>
                );
              })}
            </text>
          </svg>
        </div>
      </Wrapper>
    );
  }
}
